// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"page_responsiveContainer__aOlK4","main":"page_main__ux7yf","description":"page_description__fP9fn"};